// import Button from "react-bootstrap/Button";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, memo, useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { ImageViewer } from "../..";
import { timeHHMM } from "../../../core";
import { BotContext } from "../../context/BotContext";
import { useStyles } from "./ResponseContentStyle";
// import { Button } from "@material-ui/core";
import Button from "react-bootstrap/Button";
import { isMobile } from "react-device-detect";

const ResponseContent = memo(({ response }) => {
  const {
    globalProps,
    setButtonProps,
    askedQusetions,
    setAskedQuestions,
    inputRef,
    historyUser,
  } = useContext(BotContext);
  const {
    text,
    message,
    buttons,
    images,
    links,
    status,
    question_date,
  } = response;
  const handleButtonClick = (button) => {
    const q = {
      question: button.payload,
      label_question: button.title,
    };
    askedQusetions.splice(1, 0, q);

    setAskedQuestions(askedQusetions);
    setButtonProps(q);
    globalProps.triggerNextStep({
      value: button,
      trigger: "5",
    });
  };

  const [show, setShow] = useState(false);
  const styles = useStyles({ text });
  const [currentImage, setCurrentImage] = useState(0);
  const handleClose = () => {
    setShow(false);
    !isMobile && inputRef.current.focus();
  };
  const handleShow = (imgsrc) => {
    setShow(true);
  };

  return (
    <div className={styles.container}>
      {text && status ? (
        links && links.length > 0 ? (
          <div className={styles.text}>
            {[...text].slice(0, links[0].start).join("")}
            {links.map((link, index) => {
              return (
                <Fragment key={index}>
                  <a href={link.link}>
                    {[...text]
                      .slice(link.start, link.start + link.length)
                      .join("")}
                  </a>
                  {index < links.length - 1 &&
                    [...text]
                      .slice(link.start + link.length, links[index + 1].start)
                      .join("")}
                  {index === links.length - 1 &&
                    [...text].slice(link.start + link.length).join("")}
                </Fragment>
              );
            })}
          </div>
        ) : (
          <div className={styles.text}>{text}</div>
        )
      ) : message ? (
        <div className={styles.text}>{message}</div>
      ) : (
        <div className={styles.text}>خطا در ارسال پیام</div>
      )}

      {images && images?.length > 0 && (
        <div
          className={
            images.length > 1 ? styles.imagesBox : styles.singleImagesBox
          }
        >
          {images.map((image, index) => (
            <img
              className={styles.image}
              src={image?.link}
              onClick={() => {
                handleShow(image?.link);
                setCurrentImage(index);
              }}
              alt=""
            />
          ))}
        </div>
      )}
      {buttons && (
        <div className={styles.buttons}>
          {buttons.map((button, index) => (
            <Button
              variant="contained"
              color="primary"
              disabled={historyUser}
              key={index}
              // size="small"
              className={styles.button}
              onClick={() => {
                handleButtonClick(button);
              }}
            >
              <span>{button.title}</span>
            </Button>
          ))}
        </div>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        centered
        animation={false}
        backdropClassName={styles.backdropClassName}
        fullscreen={true}
      >
        <Modal.Body
          className={styles.modalBody}
          // style={{ background: `url(${imageSrc})` }}
        >
          <FontAwesomeIcon
            icon={faTimes}
            className={styles.closeIcon}
            onClick={handleClose}
            size="2x"
          />

          {images?.length > 0 && (
            <ImageViewer
              src={images?.map((img) => img.link)}
              currentIndex={currentImage}
              setCurrentIndex={setCurrentImage}
              disableScroll={true}
              closeOnClickOutside={true}
              onClose={() => {
                handleClose();
                setCurrentImage(0);
              }}
              description={images?.[currentImage]?.description}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
});

export { ResponseContent };
